<ng-content></ng-content>
@for (option of innerOptions; track $index) {
  <div class="checkbox"
    [ngClass]="{active: option.selected, disabled: option.disabled || disabled, preload: loading()}"
    (click)="toggle(option)">
    <div class="checkbox__view"></div>
    <div class="checkbox__label">{{ option.label }}</div>
  </div>
}
